import bowser from 'bowser';
import { useState } from 'react';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect';

// bowser.tablet or bowser.ios does not work on newer gens ipads anymore.
// This will address that issue.
export function isIpadOs(): boolean {
  if (typeof window !== 'undefined') {
    return (
      !!window.navigator.maxTouchPoints &&
      window.navigator.maxTouchPoints > 2 &&
      /MacIntel/.test(window.navigator.platform)
    );
  }
  return false;
}

export const isTouch: boolean = bowser.mobile || bowser.tablet || isIpadOs();
export const isTablet: boolean = bowser.tablet || isIpadOs();
export const isDesktop: boolean = !isTouch;
export const isMobile: boolean = bowser.mobile;

// note: always use 'afterHydration' if you are using it to 'change' your DOM,
// as it will otherwise result in a mismatch of your DOM on the client and server-side ( SSR hydration error)
export function useIsDesktopDevice(afterHydration: boolean = true): boolean {
  const [isDesktopDevice, setIsDesktopDevice] = useState(!afterHydration ? isDesktop : false);

  useIsomorphicLayoutEffect(() => {
    if (afterHydration) {
      setIsDesktopDevice(isDesktop);
    }
  }, [afterHydration, setIsDesktopDevice]);

  return isDesktopDevice;
}
